import { gsap, ScrollTrigger } from '../global/gsap';

const initPaintReveals = (reveals) => {
    reveals.forEach((revealEl) => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: revealEl,
                start: 'top 70%',
                onEnter: () => {
                    revealEl.classList.add('is-active');
                },
            },
        });
    });
};

export default initPaintReveals;
